<template>
  <div id="">

<!--     <div class="lines-history global-page linear-gradient">
        <div v-for="index in 5"
        :key="index"
        class="infoPage"></div>
    </div> -->

    <div id="background-home"></div>

    <div class="cabecera-container"
      data-aos="fade-in"
      data-aos-duration="2000"
      data-aos-delay="200">

        <div class="cabecera-parent" :style="styleObject" >
          <h1 class="pb-2"
          data-aos="fade-down"
          data-aos-duration="2000"
          data-aos-delay="500">
            {{ $t('ecoproductes') }}
          <v-icon> {{ menu[3].icon}}</v-icon>
          </h1>
        </div>

      <router-view></router-view>
     
    </div>

  </div>
</template>

<script>

export default {
  name: 'Ecoproductes',
  metaInfo() {
    return { 
      metaInfo: {
        title: this.$t('ecoproductesMetaTitle'),
      },
      title: this.$t('ecoproductesMetaTitle'),
      description: this.$t('ecoproductesMetaTitle'),
    }
  },
  props: {
    msg: String
  },
  computed: {
    menu () {
      return this.$store.state.menu
    },
    styleObject() {
      return {
        "background-color": 'rgb(189, 185, 157)',
      }
    }
  }
}

</script>

<style scoped lang="scss">

  .image-transport{
    width: 250px;
    text-align:right;
    margin: 15px;
    float: right;
  }

  .cabecera {
    &-container {
      // background-image: linear-gradient(-45deg,  #43aa20, white, white);
    }
    &-parent{
      background-image: linear-gradient(to left, #2f7917, #c0f4af);

      h1 {
        font-size: 27px;
        color:#238603;
        text-transform: uppercase;
        color: rgb(255, 255, 255);
      }
      .v-icon {
        color:#238603;
        color: black;
        color: rgb(255, 255, 255);
        font-size: 28px;
        margin-top: -7px;
      }
    }

  }


</style>
